 <!--Loading Spinner-->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>
<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">

          <div class="col-sm-6">
            <button type="button" class="btn btn-success" (click)="openAddSalesTargetModal()"><i
              class="fa fa-plus-circle" aria-hidden="true">&nbsp;</i>Add Sale Target</button>
          </div><!-- /.col -->

          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
              <li class="breadcrumb-item active">Sales Targets</li>
            </ol>
          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
      <div class="row">
        <div class="col-md-8">
            <div class="row">

            </div>
        </div>
        <div class="col-md-4">
          <div class="row">
              <div class="col">
                  <input type="text" class="form-control" placeholder="Type Sales Rep. name here to search..." (input)="onSearchTextChange($event)">
              </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    <!-- /.content-header -->
    <section class="content">
      <div class="container-fluid">
      <div class="card">
          <div class="card-header">
            <h3 class="card-title">Sales Targets</h3>
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <!--Error Message-->
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
            </div>
            <!--Success Message-->
            <div class="alert alert-success" role="alert" *ngIf="successMessage">
            {{successMessage}}
            </div>
            <table id="example1" class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Sales Rep. Name</th>
                  <th>Branch</th>
                  <th>Target Units</th>
                  <th>Created On</th>
                  <th>Updated On</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let sales_target of sales_targets | searchSalesRep: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }">
                  <td>{{sales_target.sales_rep_name}}</td>
                  <td>{{sales_target.location_name}}-{{sales_target.branch_name}}</td>
                  <td>{{sales_target.target_units}}</td>
                  <td>{{sales_target.created_at | date: 'dd-MM-yyyy'}}</td>
                  <td>{{sales_target.updated_at | date: 'dd-MM-yyyy'}}</td>
                  <td>
                    <div class="dropdown">
                        <button class="btn btn-default dropdown-toggle" type="button"
                            data-toggle="dropdown">Action
                            <span class="caret"></span></button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#" (click)="getSaleTargetInfo($event,sales_target.id)"><i class="fa fa-edit"></i>&nbsp;Edit</a></li>
                            <li><a class="dropdown-item" href="#" (click)="delete($event,sales_target.sales_rep_id)"><i class="fa fa-trash"></i>&nbsp;Delete</a></li>
                        </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
    </section>

    <!-- Add Sales Target Modal -->
    <div class="modal fade" id="addSalesTargetModal" tabindex="-1" role="dialog" aria-labelledby="salesTargetModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="salesTargetModalLabel">Add Sale Target</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
             <form [formGroup]="addTargetForm" (ngSubmit)="addSalesTarget()">
              <div class="row clearfix">
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Sales Rep.:<span style="color:red;">*</span></label>
                          <ng-select [(ngModel)]="selectedSalesRep" [ngModelOptions]="{standalone: true}">
                              <ng-option *ngFor="let salesRep of salesReps" [value]="salesRep.id">{{salesRep.name}}</ng-option>
                          </ng-select>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Target Units:<span style="color:red;">*</span></label>
                          <input type="text" formControlName="target_units" class="form-control" placeholder="Target Units" value="">

                          <span *ngIf="submitted && addTargetForm.get('target_units')?.hasError('required')" style="color:red"> <strong>Please enter target units!</strong></span>
                      </div>
                  </div>
               </div>

              <div class="modal-footer">
                <button class="btn btn-success" type="button" *ngIf="isProcessing; else showSaveBtn" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Processing...
                </button>
                <ng-template #showSaveBtn>
                    <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Save</button>
                </ng-template>

                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              </div>
           </form>
          </div>
        </div>
      </div>
    </div>

     <!-- Edit Sales Target Modal -->
    <div class="modal fade" id="editSalesTargetModal" tabindex="-1" role="dialog" aria-labelledby="salesTargetModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="salesTargetModalLabel">Edit Sale Target</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
             <form [formGroup]="updateTargetForm" (ngSubmit)="updateSalesTarget()">
              <div class="row clearfix">
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Sales Rep.:<span style="color:red;">*</span></label>
                          <input type="text" class="form-control" placeholder="Target Units" [value]="saleTarget?.name" readonly>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Target Units:<span style="color:red;">*</span></label>
                          <input type="text" formControlName="target_units" class="form-control" placeholder="Target Units">

                          <span *ngIf="submitted && updateTargetForm.get('target_units')?.hasError('required')" style="color:red"> <strong>Please enter target units!</strong></span>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Month:<span style="color:red;">*</span></label>
                          <select class="form-control" formControlName="month">
                            <option value="">Select</option>
                            <option *ngFor="let month of months" [value]="month.currOrNextMon">
                              {{ month.currOrNextMon }}
                            </option>
                          </select>

                          <span *ngIf="submitted && updateTargetForm.get('month')?.hasError('required')" style="color:red">
                            <strong>Please select a month!</strong>
                          </span>
                      </div>
                  </div>
               </div>

              <div class="modal-footer">
                <button class="btn btn-success" type="button" *ngIf="isProcessing; else showUpdateBtn" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Processing...
                </button>
                <ng-template #showUpdateBtn>
                    <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Update</button>
                </ng-template>

                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              </div>
           </form>
          </div>
        </div>
      </div>
    </div>
